import '../pages/CartsPage.css'

export default function CartCard({
  cart,
  subtitle,
  totalLabel,
  menu = null,
  className = '',
  ...props
}) {
  const name = cart?.name || 'Panier sans nom'

  const expandLongName = (event) => {
    const title = event.currentTarget
    if (title.scrollHeight > title.clientHeight + 1) {
      event.stopPropagation()
      title.classList.toggle('is-expanded')
    }
  }

  return (
    <div className={`cart-card glass-card ${className}`.trim()} title={name} {...props}>
      <div className="cart-header">
        <h3 title={name} tabIndex={0} onClick={expandLongName}>{name}</h3>
        {menu}
      </div>
      {subtitle ? <p className="cart-date">{subtitle}</p> : null}
      {totalLabel ? <div className="cart-total">{totalLabel}</div> : null}
    </div>
  )
}
